import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { useMountEffect } from "../../../hooks/LifeCycle";
import EgresosActions from "../../../stores/hospitalizacion/egresos/Actions";
import PrestadorActions from "../../../stores/prestador/Actions";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import BusquedaCierresCuentasForm from "../components/BusquedaCierresCuentasForm";
import BusquedaCierresCuentasTabla from "../components/BusquedaCierresCuentasTabla";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import ModalLoader from "../../../components/Common/ModalLoader";
import TittleLine from "../../../components/Common/TittleLine";
import { useHistory } from "react-router-dom";
import { PSS_TYPE } from "../../../utils/Constant";
import useEmpresa from "../../../hooks/useEmpresa";

const ContentWrapper = styled.div`
  min-height: calc(100vh - 180px);
  padding-bottom: 100px;
`;

const CompactSection = styled(Section)`
  padding: 10px 0;
  margin: 0;
`;

const TitleSection = styled(Section)`
  padding: 8px 0;
  margin: 0;
`;

const BusquedaCierresCuentasScreen = (props) => {
  const {
    formConsultaCierresCuentasData,
    consultarCierresCuentasLoading,
    authUserData,
    getMedicosData,
    getMedicosLoading,
    getMedicosError,
    getMedicos,
    consultarPlanesEgreso,
    consultarPlanesEgresoData,
    consultarPlanesEgresoLoading,
  } = props;

  const history = useHistory();
  const empresa = useEmpresa();

  useMountEffect(() => {
    if (authUserData?.prestador?.tipoPss === PSS_TYPE.MEDICO) {
      history.push("/dashboard");
      return;
    }
  });

  useEffect(() => {
    const prestador = authUserData?.prestador;
    const fechaInicio = formConsultaCierresCuentasData?.fechaInicio;
    const ano = fechaInicio
      ? new Date(fechaInicio).getFullYear()
      : new Date().getFullYear();
    if (prestador?.codigo && empresa?.CODIGO) {
      consultarPlanesEgreso({
        Ano: ano,
        Compania: Number(empresa.CODIGO) || 30,
        Pss: Number(prestador.codigo),
      });
    }
  }, [
    authUserData?.prestador?.codigo,
    empresa?.CODIGO,
    formConsultaCierresCuentasData?.fechaInicio,
    consultarPlanesEgreso,
  ]);

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition="fixed"
    >
      <ContentWrapper>
        <TitleSection>
          <TittleLine title={"Búsqueda de cierres de cuentas"} weight={"bold"} />
        </TitleSection>

        <CompactSection>
          <BusquedaCierresCuentasForm
            getMedicos={getMedicos}
            getMedicosData={getMedicosData}
            getMedicosLoading={getMedicosLoading}
            getMedicosError={getMedicosError}
            consultarPlanesEgresoData={consultarPlanesEgresoData}
            consultarPlanesEgresoLoading={consultarPlanesEgresoLoading}
          />
        </CompactSection>

        <BusquedaCierresCuentasTabla />
      </ContentWrapper>

      <CheckRender allowed={consultarCierresCuentasLoading}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={formConsultaCierresCuentasData?.showAlert}>
        <CustomAlert {...formConsultaCierresCuentasData?.alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formConsultaCierresCuentasData: state.egreso.formConsultaCierresCuentasData,
  formConsultaCierresCuentasLoading:
    state.egreso.formConsultaCierresCuentasLoading,

  consultarCierresCuentasLoading: state.egreso.consultarCierresCuentasLoading,

  getMedicosData: state.prestador.getMedicosData,
  getMedicosLoading: state.prestador.getMedicosLoading,
  getMedicosError: state.prestador.getMedicosError,

  consultarPlanesEgresoData: state.egreso.consultarPlanesEgresoData,
  consultarPlanesEgresoLoading: state.egreso.consultarPlanesEgresoLoading,
});

const mapDispatchToProps = {
  formConsultaCierresCuentas: EgresosActions.formConsultaCierresCuentas,
  consultarCierresCuentas: EgresosActions.consultarCierresCuentas,
  consultarPlanesEgreso: EgresosActions.consultarPlanesEgreso,
  getMedicos: PrestadorActions.getMedicos,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(BusquedaCierresCuentasScreen);
